import React, { useState, useEffect } from "react";
import api from "../../api/api";
import TransferList from "../TransferList";
import { useForm } from "react-hook-form";

const Edit = ({ setCards, item, setWarning, handleOpenSnackbar }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: item,
  });

  const onSubmit = (formData) => {
    api
      .post("/mosaics", formData)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setWarning({
            type: "success",
            message: "Mosaico editado com sucesso!",
          });
          handleOpenSnackbar();
          setCards("");
        } else {
          setWarning({
            type: "warning",
            message:
              "Mosaico editado, mas com respostas inesperadas do servidor.",
          });
          handleOpenSnackbar();
          setCards("");
        }
      })
      .catch((error) => {
        let errorMessage = "Falha ao editar o mosaico no servidor!";
        if (error.response) {
          errorMessage += ` Detalhes: ${
            error.response.data.message || error.response.status
          }`;
        } else if (error.request) {
          errorMessage = "O servidor não respondeu ao pedido.";
        } else {
          errorMessage = "Erro ao enviar o pedido para o servidor.";
        }
        setWarning({
          type: "error",
          message: errorMessage,
        });
        handleOpenSnackbar();
      });
  };

  return (
    <div className="max-w-7xl mx-auto p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Editar Mosaico
        </h1>
        <p className="text-gray-600">
          Modifique as configurações do mosaico existente
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Formulário - Lado Esquerdo */}
        <div className="lg:col-span-2">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Configurações Básicas
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label
                    htmlFor="position"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Posição *
                  </label>
                  <select
                    id="position"
                    {...register("position", {
                      required: "Selecione uma posição",
                    })}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  >
                    <option value="">Selecione uma posição</option>
                    <option value="LEFT">1 - Esquerda</option>
                    <option value="RIGHT">2 - Direita</option>
                    <option value="BOTTOM_LEFT">3 - Inferior Esquerda</option>
                    <option value="BOTTOM_RIGHT">4 - Inferior Direita</option>
                  </select>
                  {errors.position && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.position.message}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="title"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Título *
                  </label>
                  <input
                    type="text"
                    id="title"
                    placeholder="Digite o título do mosaico"
                    {...register("title", { required: "Título é obrigatório" })}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  />
                  {errors.title && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.title.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="mt-6">
                <label
                  htmlFor="text"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Descrição *
                </label>
                <textarea
                  id="text"
                  rows="3"
                  placeholder="Digite a descrição do mosaico"
                  {...register("text", { required: "Descrição é obrigatória" })}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                />
                {errors.text && (
                  <p className="mt-1 text-sm text-red-600">
                    {errors.text.message}
                  </p>
                )}
              </div>

              <div className="mt-6">
                <label
                  htmlFor="href"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Link *
                </label>
                <input
                  type="url"
                  id="href"
                  placeholder="https://exemplo.com"
                  {...register("href", {
                    required: "Link é obrigatório",
                    pattern: {
                      value: /^https?:\/\/.+/,
                      message:
                        "Digite uma URL válida começando com http:// ou https://",
                    },
                  })}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
                {errors.href && (
                  <p className="mt-1 text-sm text-red-600">
                    {errors.href.message}
                  </p>
                )}
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Imagens e Mídia
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label
                    htmlFor="imgUrl"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    URL da Imagem Desktop
                  </label>
                  <input
                    type="url"
                    id="imgUrl"
                    placeholder="https://exemplo.com/imagem.jpg"
                    {...register("imgUrl")}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  />
                  <div className="mt-2 text-xs text-gray-500 space-y-1">
                    <p>• Posição 1: 300x600 ou vídeo</p>
                    <p>• Posição 2: 1708x536</p>
                    <p>• Posições 3 e 4: 836x536</p>
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="imgUrlMobile"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    URL da Imagem Mobile
                  </label>
                  <input
                    type="url"
                    id="imgUrlMobile"
                    placeholder="https://exemplo.com/imagem-mobile.jpg"
                    {...register("imgUrlMobile")}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  />
                  <div className="mt-2 text-xs text-gray-500 space-y-1">
                    <p>• Posição 1: 300x600 ou vídeo</p>
                    <p>• Posições 2, 3 e 4: 836x536</p>
                  </div>
                </div>
              </div>

              <div className="mt-6">
                <label
                  htmlFor="videoUrl"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  URL do Vídeo (Opcional)
                </label>
                <input
                  type="url"
                  id="videoUrl"
                  placeholder="https://exemplo.com/video.mp4"
                  {...register("videoUrl")}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
                <p className="mt-2 text-xs text-gray-500">
                  URL do vídeo para reprodução no mosaico
                </p>
              </div>
            </div>

            <div className="flex gap-4 pt-6">
              <button
                type="button"
                onClick={() => setCards("")}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out transform hover:scale-105"
              >
                Salvar Alterações
              </button>
            </div>
          </form>
        </div>

        {/* Caixa de Alerta - Lado Direito */}
        <div className="lg:col-span-1">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 sticky top-6">
            <h2 className="text-xl font-semibold text-yellow-800 mb-3">
              Editando Mosaico Existente
            </h2>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-yellow-700">
                  <strong>Título:</strong> {item?.title || "Não definido"}
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-yellow-700">
                  <strong>Posição:</strong> {item?.position || "Não definida"}
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-yellow-700">
                  <strong>Vídeo:</strong>{" "}
                  {item?.videoUrl ? "Configurado" : "Não configurado"}
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-yellow-700">
                  <strong>Mobile:</strong>{" "}
                  {item?.imgUrlMobile ? "Configurado" : "Não configurado"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
